document.documentElement.classList.remove('no-js');

const showToast = (message) => {
  const toast = document.querySelector('[data-site-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(window.__prisomaToastTimer);
  window.__prisomaToastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
};

if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
} else {
  document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
}

document.querySelectorAll('[data-collection-tabs]').forEach((section) => {
  const tabs = Array.from(section.querySelectorAll('[data-tab-target]'));
  const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tabTarget;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => panel.classList.toggle('is-hidden', panel.dataset.tabPanel !== target));
    });
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.nav-dropdown[open]').forEach((dropdown) => {
    if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
  });
});

document.querySelectorAll('[data-quantity-control]').forEach((control) => {
  const input = control.querySelector('[data-qty-input]');
  const minus = control.querySelector('[data-qty-minus]');
  const plus = control.querySelector('[data-qty-plus]');
  if (!input) return;
  minus?.addEventListener('click', () => {
    input.value = Math.max(1, Number(input.value || 1) - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  plus?.addEventListener('click', () => {
    input.value = Math.max(1, Number(input.value || 1) + 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const select = section.querySelector('[data-variant-select]');
  const priceWrap = section.querySelector('[data-product-price]');
  const stickyVariant = section.querySelector('[data-sticky-variant]');
  const stickyPrice = section.querySelector('[data-sticky-price]');
  if (!select || !priceWrap) return;

  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = option.dataset.price || '';
    const compare = option.dataset.compare || '';
    priceWrap.innerHTML = `<span>${price}</span>${compare ? `<s>${compare}</s>` : ''}`;
    if (stickyVariant) stickyVariant.value = option.value;
    if (stickyPrice) stickyPrice.textContent = price;
  });
});

document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
});

document.querySelectorAll('[data-coming-soon]').forEach((card) => {
  const activate = () => showToast(card.dataset.comingSoonMessage || 'Coming soon');
  card.addEventListener('click', activate);
  card.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      activate();
    }
  });
});

// Ajax cart drawer. All standard Shopify add-to-cart forms keep a normal fallback if JS is unavailable.
(() => {
  const shell = document.querySelector('[data-cart-drawer-shell]');
  if (!shell) return;
  const rootUrl = (document.body.dataset.rootUrl || '/').replace(/\/?$/, '/');
  const itemsWrap = shell.querySelector('[data-cart-drawer-items]');
  const footer = shell.querySelector('[data-cart-drawer-footer]');
  const subtotal = shell.querySelector('[data-cart-drawer-subtotal]');
  const drawerCount = shell.querySelector('[data-cart-drawer-count]');
  let closeTimer;
  const cartDuration = Math.max(260, Math.min(600, parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cart-duration')) || 380));

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[char]));
  const money = (cents, currency = 'INR') => {
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch { return `₹${((Number(cents) || 0) / 100).toFixed(2)}`; }
  };
  const updateCounts = (count) => {
    document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = count; });
    document.querySelectorAll('[data-cart-drawer-count]').forEach((el) => { el.textContent = count; });
  };
  const open = () => {
    window.clearTimeout(closeTimer);
    shell.classList.remove('is-closing');
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    requestAnimationFrame(() => shell.classList.add('is-open'));
  };
  const close = () => {
    window.clearTimeout(closeTimer);
    shell.classList.remove('is-open');
    shell.classList.add('is-closing');
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    closeTimer = window.setTimeout(() => { shell.hidden = true; shell.classList.remove('is-closing'); }, cartDuration);
  };
  const emptyMarkup = () => `<div class="cart-drawer__empty"><span>00</span><h3>Your cart is waiting.</h3><p>Choose a PRISOMA format and build your everyday ritual.</p><a class="btn btn--primary" href="${rootUrl}collections/all">Shop all products</a></div>`;
  const render = (cart) => {
    updateCounts(cart.item_count || 0);
    if (!cart.items?.length) {
      itemsWrap.innerHTML = emptyMarkup();
      if (footer) footer.hidden = true;
      return;
    }
    itemsWrap.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${escapeHtml(item.variant_title)}</div>` : '';
      return `<article class="cart-line" data-cart-key="${escapeHtml(item.key)}">
        <a class="cart-line__media" href="${escapeHtml(item.url)}">${image}</a>
        <div class="cart-line__body">
          <div class="cart-line__top"><div><a class="cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}</div><strong>${money(item.final_line_price, cart.currency)}</strong></div>
          <div class="cart-line__bottom">
            <div class="cart-line__qty" aria-label="Quantity"><button type="button" data-cart-quantity data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button></div>
            <button class="cart-line__remove" type="button" data-cart-remove data-key="${escapeHtml(item.key)}">Remove</button>
          </div>
        </div>
      </article>`;
    }).join('');
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);
    if (footer) footer.hidden = false;
  };
  const getCart = async () => {
    const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    render(cart);
    return cart;
  };
  const change = async (key, quantity) => {
    const response = await fetch(`${rootUrl}cart/change.js`, { method: 'POST', headers: { 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ id:key, quantity:Math.max(0, Number(quantity)||0) }) });
    if (!response.ok) throw new Error('Cart update failed');
    const cart = await response.json();
    render(cart);
  };

  document.querySelectorAll('[data-cart-open]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); getCart().catch(()=>{}).finally(open); }));
  shell.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !shell.hidden) close(); });
  shell.addEventListener('click', async (event) => {
    const qty = event.target.closest('[data-cart-quantity]');
    const remove = event.target.closest('[data-cart-remove]');
    if (!qty && !remove) return;
    const target = qty || remove;
    target.disabled = true;
    try { await change(target.dataset.key, remove ? 0 : target.dataset.quantity); }
    catch { showToast('Could not update cart. Please try again.'); }
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (submitter?.name === 'checkout') return;
      event.preventDefault();
      const button = submitter || form.querySelector('button[type="submit"]');
      const original = button?.innerHTML;
      if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
        if (!response.ok) throw new Error('Unable to add item');
        await getCart();
        open();
      } catch {
        showToast('Could not add this item. Please try again.');
      } finally {
        if (button) { button.disabled = false; button.innerHTML = original; }
      }
    });
  });
})();

// In-place search drawer + predictive product results.
(() => {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  const drawer = overlay.querySelector('[data-search-drawer]');
  const input = overlay.querySelector('[data-live-search-input]');
  const results = overlay.querySelector('[data-search-suggestions]');
  const rootUrl = (drawer?.dataset.rootUrl || '/').replace(/\/?$/, '/');
  let timer;
  let controller;

  const open = () => {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    window.setTimeout(() => input?.focus(), 30);
  };
  const close = () => {
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
  };

  document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', open));
  overlay.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !overlay.hidden) close(); });

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[char]));

  const render = (products, query) => {
    if (!products.length) {
      results.innerHTML = `<div class="search-suggestions__empty">No PRISOMA products found for “${escapeHtml(query)}”.</div>`;
      return;
    }
    results.innerHTML = products.map((product) => {
      const image = product.image ? `<img src="${escapeHtml(product.image)}" alt="" loading="lazy">` : '';
      const price = product.price || '';
      return `<a class="search-result" href="${escapeHtml(product.url)}">
        <span class="search-result__media">${image}</span>
        <span><span class="search-result__title">${escapeHtml(product.title)}</span><span class="search-result__meta">${escapeHtml(price)}</span></span>
        <span class="search-result__arrow" aria-hidden="true">↗</span>
      </a>`;
    }).join('') + `<a class="search-all" href="${rootUrl}search?q=${encodeURIComponent(query)}&type=product"><span>View all results</span><span aria-hidden="true">↗</span></a>`;
  };

  input?.addEventListener('input', () => {
    const query = input.value.trim();
    window.clearTimeout(timer);
    if (controller) controller.abort();
    if (query.length < 2) {
      results.innerHTML = '<div class="search-suggestions__empty">Start typing to search the PRISOMA range.</div>';
      return;
    }
    results.innerHTML = '<div class="search-suggestions__loading">Searching…</div>';
    timer = window.setTimeout(async () => {
      try {
        controller = new AbortController();
        const url = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Search failed');
        const payload = await response.json();
        render(payload?.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '<div class="search-suggestions__empty">Search is temporarily unavailable. Press Enter to continue.</div>';
      }
    }, 180);
  });
})();

// Universal PRISOMA collection filters: category, quantity, flavour and price.
(() => {
  const filters = document.querySelector('[data-shop-filters]');
  const results = document.querySelector('[data-shop-grouped]');
  if (!filters || !results) return;
  const categoryButtons = Array.from(filters.querySelectorAll('[data-shop-category]'));
  const flavourInputs = Array.from(filters.querySelectorAll('[data-shop-flavour]'));
  const quantityInputs = Array.from(filters.querySelectorAll('[data-shop-quantity]'));
  const minInput = filters.querySelector('[data-shop-price-min]');
  const maxInput = filters.querySelector('[data-shop-price-max]');
  const reset = filters.querySelector('[data-shop-reset]');
  const cards = Array.from(results.querySelectorAll('.collection-product[data-price]'));
  const groups = Array.from(results.querySelectorAll('[data-product-group]'));
  const noResults = results.querySelector('[data-shop-no-results]');
  let category = 'all';

  const apply = () => {
    const flavours = flavourInputs.filter((input) => input.checked).map((input) => input.value);
    const quantities = quantityInputs.filter((input) => input.checked).map((input) => input.value);
    const min = Number(minInput?.value || 0) * 100;
    const max = Number(maxInput?.value || 0) * 100;
    let visibleTotal = 0;

    cards.forEach((card) => {
      const cardCategory = card.dataset.format || 'other';
      const cardFlavour = card.dataset.flavour || 'other';
      const cardQuantity = card.dataset.quantity || 'other';
      const price = Number(card.dataset.price || 0);
      const categoryMatch = category === 'all' || category === cardCategory;
      const flavourMatch = flavours.length === 0 || flavours.includes(cardFlavour);
      const quantityMatch = quantities.length === 0 || quantities.includes(cardQuantity);
      const priceMatch = (!min || price >= min) && (!max || price <= max);
      const visible = categoryMatch && flavourMatch && quantityMatch && priceMatch;
      card.hidden = !visible;
      if (visible) visibleTotal += 1;
    });

    groups.forEach((group) => {
      const groupCards = Array.from(group.querySelectorAll('.collection-product'));
      group.hidden = !groupCards.some((card) => !card.hidden);
    });
    if (noResults) noResults.hidden = visibleTotal !== 0;
  };

  categoryButtons.forEach((button) => button.addEventListener('click', () => {
    category = button.dataset.shopCategory || 'all';
    categoryButtons.forEach((item) => item.classList.toggle('is-active', item === button));
    apply();
  }));
  flavourInputs.forEach((input) => input.addEventListener('change', apply));
  quantityInputs.forEach((input) => input.addEventListener('change', apply));
  minInput?.addEventListener('input', apply);
  maxInput?.addEventListener('input', apply);
  reset?.addEventListener('click', () => {
    category = 'all';
    categoryButtons.forEach((item) => item.classList.toggle('is-active', item.dataset.shopCategory === 'all'));
    flavourInputs.forEach((input) => { input.checked = false; });
    quantityInputs.forEach((input) => { input.checked = false; });
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';
    apply();
  });

  apply();
})();
